import ICheckableGroup from '@inkline/inkline/src/components/ICheckableGroup';

export default {
    name: 'IRadioGroup',
    extends: ICheckableGroup
};
